import DownloadPdfButton from '../ui/download-pdf-button'
import { cx } from '@/utils/strings'
import colors from '@/constants/colors'
import { buttonStyles } from '../ui/cta-link'

export default function HelpDownloadPDF({
  isButtonStyle,
  inHelpDrawer,
}: {
  isButtonStyle?: boolean
  inHelpDrawer?: boolean
}) {
  const renderButton = () => (
    <DownloadPdfButton
      className={cx(
        !isButtonStyle && !inHelpDrawer && 'text-sm font-bold text-primaryBlue',
        inHelpDrawer &&
          '[&_span.font-bwi]:ml-2 [&_span.font-bwi]:mr-0 [&>span]:items-end [&>span]:flex-row-reverse hover:text-white'
      )}
      btnText="Download as PDF"
      buttonStyle={isButtonStyle ? buttonStyles.btnSolid : buttonStyles.btnText}
      backgroundColor={colors.white}
      size="Smaller"
    />
  )
  return inHelpDrawer ? <div className="flex items-end justify-end mr-5">{renderButton()}</div> : renderButton()
}
